import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

export function deleteAuthFederationConnectorRequestConfig(luid: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.30',
    httpMethod: 'DELETE',
    endpoint: `auth-federation/admin/connectors/${luid}`,
    serverWideRequest: false
  };
}

export function callDeleteAuthFederationConnectorRequest(luid: string): Promise<void> {
  return makeJsonRestApiRequest<null, any>({
    config: deleteAuthFederationConnectorRequestConfig(luid),
    request: null
  }).then(() => {
    // DELETE returns 204 No Content
    return;
  });
}
